
define('template!catalogsCreateTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="catalogs-create-tpl">\n  <div class="item">\n    <div class="libelle">' +
((__t = ( _.i18n('common.name') || 'Name' )) == null ? '' : __t) +
'</div>\n    <div class="value name-region"></div>\n  </div>\n</div>\n';

}
return __p
};});

